<template>
	<div>
		<section class="content-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6">
                    <h3>{{ $t('label.application') }}</h3>
                </div>
                <div class="col-md-6">
                    <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
                        <li class="breadcrumb-item"><router-link to="/application">{{ $t("label.application")}}</router-link></li>
                        <li class="breadcrumb-item active">{{ $t("label.view")}}</li>
                    </ol>
                </div>
            </div>
        </div>
      </section>
		<div class="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-md-12 col-12">
            <!-- Start lodgement assess Declined -->
            <div v-if="declaration.lodgement != null && declaration.lodgement.status === 'Decline'" class="card card-default">

              <div class="alert alert-error show mb-0">
                  <span>{{$t('label.lodgement_assess_status')}}: <strong>{{$t('label.decline')}}</strong></span>
              </div>

            </div>
            <!-- End // -->

            <!-- Start destination assess Declined -->
            <div v-if="declaration.destination != null && declaration.destination.status === 'Decline'" class="card card-default">

              <div class="alert alert-error show mb-0">
                  <span>{{$t('label.destination_assess_status')}}: <strong>{{$t('label.decline')}}</strong></span>
              </div>

            </div>
            <!-- End // -->

						<!-- Start amendment notification alert -->
						<div class="card card-default" v-if="getAmendment('office') !== null">
							<div class="card-header">
								<h3 class="card-title custom-card-title"><fa :icon="['fas', 'road']"></fa>{{ declaration.registration_type === 'EX' ? $t("label.request_change_entry_office") : $t("label.request_change_exit_office") }}</h3>
								<div class="card-tools">
									<button v-if="$hasPermission('tempvehicle.amendment.approve')" @click="showVerifyAmendmentModal(getAmendment('office', true), 'Approve', 'office')" class="btn btn-xs btn-success float-right ml-1">Approve</button>
									<button v-if="$hasPermission('tempvehicle.amendment.decline')" @click="showVerifyAmendmentModal(getAmendment('office', true), 'Decline', 'office')" class="btn btn-xs btn-danger float-right mr-1">Decline</button>
								</div>
							</div>
							<div class="card-body">
								<div class="col-12" v-if="getAmendment('office') !== null">
									<div class="alert alert-warning show">
										<span>From <strong>{{ getAmendment('office')['old']}}</strong> To <strong>{{ getAmendment('office')['new']}}</strong></span>
										<template v-if="!$hasPermission('tempvehicle.assess.view')">
											<button @click="doAmendment(getAmendment('office', true), 'cancel', 'office')" type="button" class="close float-right ml-1">
												<span aria-hidden="true">&times;</span>
											</button>
											<span class="float-right mr-1">Status: <strong>Pending</strong></span>
										</template>
									</div>
									<div>
										{{$t('label.description')}} : {{getAmendment('office')['description']}}
									</div>
									<div>
										<table class="table" v-if="getAmendment('office')['attachments'].length > 0">
											<tbody>
												<tr v-for="(attachment, index) in getAmendment('office')['attachments']" :key="index">
													<td style="margin-left: 0px; !important;">
														<span @click="viewImage(attachment.path)" class="text-success cursor-pointer" :title="$t('message.click_to_view')">
														{{ attachment.original_name.substring(attachment.original_name.length - 40 , attachment.original_name.length) }}
														</span>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>

						<div class="card card-default" v-if="getAmendment('date') !== null">
							<div class="card-header">
								<h3 class="card-title custom-card-title"><fa :icon="['fas', 'clock']"></fa>{{ declaration.registration_type === 'EX' ? $t("label.request_change_entry_date") : $t("label.request_change_exit_date") }}</h3>
								<div class="card-tools">
									<button v-if="$hasPermission('tempvehicle.amendment.approve')" @click="showVerifyAmendmentModal(getAmendment('date', true),'Approve', 'date')" class="btn btn-xs btn-success float-right ml-1">Approve</button>
									<button v-if="$hasPermission('tempvehicle.amendment.decline')" @click="showVerifyAmendmentModal(getAmendment('date', true),'Decline', 'date')" class="btn btn-xs btn-danger float-right mr-1">Decline</button>
								</div>
							</div>
							<div class="card-body">
								<div class="col-12" v-if="getAmendment('date') !== null">
									<div class="alert alert-warning show">
										<span>From <strong>{{getAmendment('date')['old']}}</strong> To <strong>{{getAmendment('date')['new']}}</strong></span>
										<template v-if="!$hasPermission('tempvehicle.assess.view')">
											<button @click="doAmendment(getAmendment('date', true), 'cancel', 'date')" class="close float-right ml-1">
												<span aria-hidden="true">&times;</span>
											</button>
											<span class="float-right mr-1">Status: <strong>Pending</strong></span>
										</template>
									</div>
									<div>
										{{$t('label.description')}} : {{getAmendment('date')['description']}}
									</div>
									<div>
										<table class="table" v-if="getAmendment('date')['attachments'].length > 0">
											<tbody>
												<tr v-for="(attachment, index) in getAmendment('date')['attachments']" :key="index">
													<td style="margin-left: 0px; !important;">
														<span @click="viewImage(attachment.path)" class="text-success cursor-pointer" :title="$t('message.click_to_view')">
														{{ attachment.original_name.substring(attachment.original_name.length - 40 , attachment.original_name.length) }}
														</span>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						<!-- End // -->

						<!-- Start button header (lodgement, destination, overstay & request amendment) -->
						<div class="button-header text-right">
							<button v-if="getAmendment('office') === null && getAmendment('date') === null && !isLodgementAssessDeclined(declaration)" type="button" @click="print(srcPrint)" class="btn btn-sm btn-primary mb-2 float-right">
								<fa :icon="fas.faPrint"></fa>
								{{ $t('label.print') }}
							</button>
							<button type="button" class="btn btn-secondary btn-sm mr-2 mb-2 float-right" data-toggle="modal" data-target="#viewQrcode">
								<fa :icon="fas.faQrcode"></fa>
								{{ $t('label.qrcode') }}
							</button>

              <button v-if="$hasPermission('tempvehicle.assess.view') && declaration.lodgement == null" type="button" @click="performLodgementAction('Approve')" class="btn btn-success btn-sm mr-2 mb-2" data-toggle="modal" data-target="#lodgement">
                <fa :icon="fas.faCheck"></fa>
                {{ $t('label.approve') }}
              </button>
              <button v-if="$hasPermission('tempvehicle.assess.view') && declaration.lodgement == null" type="button" @click="performLodgementAction('Reject')" class="btn btn-danger btn-sm mr-2 mb-2" data-toggle="modal" data-target="#lodgement">
                <fa :icon="fas.faTimes"></fa>
                {{ $t('label.reject') }}
              </button>

              <button v-if="$hasPermission('tempvehicle.destination.view') && declaration.lodgement != null && ['Approve','approve','APPROVE'].includes(declaration.lodgement.status) && getAmendment('office') === null && getAmendment('date') === null"
                  type="button"
                  class="btn btn-info btn-sm mr-2 mb-2"
                  @click="prepareForModalData('destination')"
                  data-toggle="modal" data-target="#destination">
                <fa :icon="['fas','road']"></fa>
                {{ $t('label.destination') }}
              </button>

              <button v-if="$hasPermission('tempvehicle.overstay.view') && declaration.lodgement != null && ['Approve','approve','APPROVE'].includes(declaration.lodgement.status) && is_overstay === true"
                      type="button"
                      class="btn btn-sm btn-warning mr-2 mb-2"
                      @click="prepareForModalData('resolve')"
                      data-toggle="modal" data-target="#resolve">
                <fa :icon="['fas','hammer']"></fa>
                {{ $t('label.resolve') }}
              </button>

              <div v-if="declaration.lodgement != null
								&& (getAmendment('office') === null || getAmendment('date') === null)
								&& declaration.destination === null
								&& declaration.lodgement.status !== 'Decline'"
                   class="dropdown d-inline">
                <button type="button" class="btn btn-sm btn-info mr-2 mb-2" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <fa :icon="fas.faEdit"></fa>
                  {{ $t('label.request_change') }}
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a v-if="getAmendment('office') === null" data-toggle="modal" data-target="#amendOffice" class="dropdown-item" href="#"><fa :icon="['fas','door-open']"></fa> {{declaration.registration_type === 'EX' ? $t("label.change_border_gate_of_entry") : $t("label.change_border_gate_of_exit")}}</a>
                  <a v-if="getAmendment('date') === null && declaration.can_extend_date" data-toggle="modal" data-target="#amendDate" class="dropdown-item" href="#"><fa :icon="['fas','clock']"></fa> {{declaration.registration_type === 'EX' ? $t("label.extended_date_of_entry") : $t("label.extended_date_of_exit")}}</a>
                </div>
              </div>

						</div>
						<!-- End button header (lodgement, destination, overstay & request amendment) // -->
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-12">
						<!-- Start Customs registration -->
						<div class="card card-default" v-if="declaration.registration_type">
							<div class="card-header">
								<h3 class="card-title custom-card-title"><fa :icon="['fas', 'door-open']"></fa>{{ $t("label.customs_registration") }}</h3>
								<div class="card-tools">
									<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.customs ? $t('label.expand') : $t('label.collapse')" @click="collapse.customs = !collapse.customs">
										<fa :icon="collapse.customs ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
									</button>
								</div>
							</div>
							<div class="card-body">
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{$t('label.register_type')}}</label>
									<div class="col-md-8">
										<select class="form-control" id="register_type" v-model="declaration.registration_type" disabled="true" tabindex="-1">
											<option value="IM">{{$t('label.temporary_import')}}</option>
											<option value="EX">{{$t('label.temporary_export')}}</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{$t('label.register_number')}}</label>
									<div class="col-md-8">
										<input type="text" class="form-control" :placeholder="$t('label.register_number')" :value="declaration.registration_year + ' ' + declaration.registration_serial + ' ' + declaration.registration_number" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label" v-if="declaration.registration_type!=='EX'">{{ $t('label.entry_office_name')}}</label>
									<label class="col-md-4 col-form-label" v-else>{{ $t('label.exit_office_name')}}</label>
									<div class="col-md-8">
										<input type="text" :value="declaration.lodgement_office_code + ' - ' + declaration.lodgement_office_name" :placeholder="$t('label.entry_office_name')" :disabled="true" class="form-control" readonly tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label" v-if="declaration.registration_type!=='EX'">{{ $t('label.entry_date')}}</label>
									<label class="col-md-4 col-form-label" v-else>{{ $t('label.exit_date')}}</label>
									<div class="col-md-8">
										<datepicker v-model="declaration.lodgement_office_date" :bootstrapStyling="true" input-class="form-control form-control-datepicker"  format="dd/MM/yyyy" :placeholder="'DD/MM/YYYY'" :disabled="true"></datepicker>
									</div>
								</div>
								<div class="form-group row">
									<label for="destination_office" class="col-md-4 col-form-label" v-if="declaration.registration_type==='EX'">{{$t('label.entry_office_name')}}</label>
									<label for="destination_office" class="col-md-4 col-form-label" v-else>{{$t('label.exit_office_name')}}</label>
									<div class="col-md-8">
										<input type="text" :value="declaration.destination_office_code + ' - ' + declaration.destination_office_name" id="destination_office" :placeholder="$t('label.exit_office_name')" :disabled="true" class="form-control" readonly tabindex="-1" />
									</div>
								</div>
								<div class="form-group row mb-0">
									<label class="col-md-4 col-form-label" v-if="declaration.registration_type==='EX'">{{ $t('label.entry_date')}}</label>
									<label class="col-md-4 col-form-label" v-else>{{ $t('label.exit_date')}}</label>
									<div class="col-md-8">
										<datepicker v-model="declaration.destination_office_date" :bootstrapStyling="true" input-class="form-control form-control-datepicker"  format="dd/MM/yyyy" :placeholder="'DD/MM/YYYY'" :disabled="true"></datepicker>
									</div>
								</div>
							</div>
						</div>
						<!-- End // -->

						<!-- Start Owner information -->
						<div class="card card-default">
							<div class="card-header">
								<h3 class="card-title custom-card-title"><fa :icon="['fas', 'user']"></fa> {{ $t('label.owner_information') }}</h3>
								<div class="card-tools">
									<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.owner ? $t('label.expand') : $t('label.collapse')" @click="collapse.owner = !collapse.owner">
										<fa :icon="collapse.owner ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
									</button>
								</div>
							</div>
							<div class="card-body" v-if="declaration.owner.first_name">
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.first_name') }}</label>
									<div class="col-md-8">
										<input type="text" class="form-control" :placeholder="$t('label.first_name')" v-model="declaration.owner.first_name" :disabled="true" readonly tabindex="-1"/>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.last_name') }}</label>
									<div class="col-md-8">
										<input type="text" class="form-control" :placeholder="$t('label.last_name')" v-model="declaration.owner.last_name" :disabled="true" readonly tabindex="-1"/>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.nationality') }}</label>
									<div class="col-md-8">
										<input type="text" class="form-control" :placeholder="$t('label.nationality')" v-model="declaration.owner.nationality" :disabled="true" readonly tabindex="-1"/>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.gender') }}</label>
									<div class="col-md-8">
										<select class="form-control" v-model="declaration.owner.gender" :disabled="true">
											<option value="m">{{ $t('label.male') }}</option>
											<option value="f">{{ $t('label.female') }}</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.passport_number') }}</label>
									<div class="col-md-8">
										<input type="text" class="form-control" :placeholder="$t('label.passport_number')" v-model="declaration.owner.passport_number" :disabled="true" readonly tabindex="-1"/>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.passport_issued_date') }}</label>
									<div class="col-md-8">
										<datepicker v-model="declaration.owner.passport_issued_date" :bootstrap-styling="true" :disabled="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker readonly"></datepicker>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.passport_expired_date') }}</label>
									<div class="col-md-8">
										<datepicker v-model="declaration.owner.passport_expired_date" :bootstrap-styling="true" :disabled="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker readonly"></datepicker>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.border_pass_number') }}</label>
									<div class="col-md-8">
										<input type="text" class="form-control" :placeholder="$t('label.border_pass_number')" v-model="declaration.owner.border_pass_number" :disabled="true" readonly tabindex="-1"/>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.border_pass_date') }}</label>
									<div class="col-md-8">
										<datepicker v-model="declaration.owner.border_pass_date" :bootstrap-styling="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker" :disabled="true" readonly tabindex="-1"></datepicker>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.identity_number') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.owner.identity_card_number" class="form-control" :placeholder="$t('label.identity_number')" :disabled="true" readonly tabindex="-1"/>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.identity_date') }}</label>
									<div class="col-md-8">
										<datepicker v-model="declaration.owner.identity_card_issued_date" :bootstrap-styling="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker readonly" :disabled="true" readonly tabindex="-1"></datepicker>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.identity_card_expired_date') }}</label>
									<div class="col-md-8">
										<datepicker v-model="declaration.owner.identity_card_expired_date" :bootstrap-styling="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker readonly" :disabled="true" readonly tabindex="-1"></datepicker>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-lg-4 col-form-label">{{ $t('label.address_in_cambodia') }}</label>
									<div class="col-md-8 col-lg-8">
										<input type="text" class="form-control" :placeholder="$t('label.address_in_cambodia')" v-model="declaration.owner.address" :disabled="true" readonly tabindex="-1"/>
									</div>
								</div>
								<div class="form-group row mb-0">
									<label class="col-md-4 col-form-label">{{ $t('label.length_of_stay') }}</label>
									<div class="col-md-8">
										<input type="text" class="form-control" :placeholder="$t('label.length_of_stay')" v-model="declaration.owner.inbound_stay" :disabled="true" readonly tabindex="-1"/>
									</div>
								</div>
							</div>
						</div>
						<!-- End //-->

						<!-- Start Vehicle information -->
						<div class="card card-default">
							<div class="card-header">
								<h3 class="card-title custom-card-title"><fa :icon="['fas', 'car']"></fa> {{ $t('label.vehicle_information') }}</h3>
								<div class="card-tools">
									<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.vehicle ? $t('label.expand') : $t('label.collapse')" @click="collapse.vehicle = !collapse.vehicle">
										<fa :icon="collapse.vehicle ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
									</button>
								</div>
							</div>
							<div class="card-body mb-0" v-if="declaration.vehicles.length > 0">
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.plate_number') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.vehicles[0].plate_number" class="form-control" :placeholder="$t('label.plate_number')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.nationality') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.vehicles[0].nationality" class="form-control" :placeholder="$t('label.nationality')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.brand') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.vehicles[0].brand" class="form-control" :placeholder="$t('label.brand')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.color') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.vehicles[0].color" class="form-control" :placeholder="$t('label.color')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.frame_number') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.vehicles[0].frame_number" class="form-control frame_number" :placeholder="$t('label.frame_number')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.engine_number') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.vehicles[0].engine_number" class="form-control engine_number" :placeholder="$t('label.engine_number')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.year') }}</label>
									<div class="col-md-8">
										<input type="number" v-model="declaration.vehicles[0].year" class="form-control" :placeholder="$t('label.year')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div style="text-align:right;">
									<a href="#"  @click.prevent="viewVehicleDetail" :title="$t('label.view_detail')">
									{{ $t('label.view_detail') }}
									</a>
								</div>
							</div>
						</div>
						<!-- End // -->

						<!-- Start Driver information -->
						<div class="card card-default">
							<div class="card-header">
								<h3 class="card-title custom-card-title"><fa :icon="['fas', 'users']"></fa> {{ $t('label.driver_information') }}</h3>
								<div class="card-tools">
									<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.driver ? $t('label.expand') : $t('label.collapse')" @click="collapse.driver = !collapse.driver">
										<fa :icon="collapse.driver ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
									</button>
								</div>
							</div>
							<div class="card-body mb-0" v-if="declaration.drivers.length > 0">
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.last_name') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.drivers[0].last_name" class="form-control" :placeholder="$t('label.last_name')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.first_name') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.drivers[0].first_name" class="form-control" :placeholder="$t('label.first_name')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.gender') }}</label>
									<div class="col-md-8">
										<input type="text" v-if="declaration.drivers[0].gender == 'f'" value="Female" class="form-control" :placeholder="$t('label.gender')" readonly disabled tabindex="-1" />
										<input type="text" v-else value="Male" class="form-control" :placeholder="$t('label.gender')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.nationality') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.drivers[0].nationality" class="form-control" :placeholder="$t('label.nationality')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.identity_number') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.drivers[0].identity_card_number" class="form-control" :placeholder="$t('label.identity_number')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.identity_date') }}</label>
									<div class="col-md-8">
                    <datepicker v-model="declaration.drivers[0].identity_card_issued_date" :bootstrap-styling="true" :clear-button="false" :highlighted="highlightedCurrentDate" :language="lang" :disabled="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker"></datepicker>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.identity_card_expired_date') }}</label>
									<div class="col-md-8">
                    <datepicker v-model="declaration.drivers[0].identity_card_expired_date" :bootstrap-styling="true" :clear-button="false" :highlighted="highlightedCurrentDate" :language="lang" :disabled="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker"></datepicker>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.passport_number') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.drivers[0].passport_number" class="form-control" :placeholder="$t('label.passport_number')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.passport_issued_date') }}</label>
									<div class="col-md-8">
                    <datepicker v-model="declaration.drivers[0].passport_issued_date" :bootstrapStyling="true" input-class="form-control form-control-datepicker"  format="dd/MM/yyyy" :placeholder="'DD/MM/YYYY'" :disabled="true"></datepicker>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.passport_expired_date') }}</label>
									<div class="col-md-8">
                    <datepicker v-model="declaration.drivers[0].passport_expired_date" :bootstrap-styling="true" :clear-button="false" :highlighted="highlightedCurrentDate" :language="lang" :disabled="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker"></datepicker>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.border_pass_number') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.drivers[0].border_pass_number" class="form-control" :placeholder="$t('label.border_pass_number')" readonly disabled tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.border_pass_date') }}</label>
									<div class="col-md-8">
										<datepicker v-model="declaration.drivers[0].border_pass_date" :bootstrap-styling="true" :clear-button="false" :highlighted="highlightedCurrentDate" :language="lang" :disabled="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker"></datepicker>
									</div>
								</div>
								<div style="text-align:right;">
									<a href="#" type="button" @click.prevent="viewDriverDetail" :title="$t('label.view_detail')">
										{{ $t('label.view_detail') }}
									</a>
								</div>
							</div>
						</div>
						<!-- End //-->

						<!-- Start Company information -->
						<div class="card card-default" v-if="declaration.company_code">
							<div class="card-header">
								<h3 class="card-title custom-card-title"><fa :icon="['fas', 'hotel']"></fa> {{ $t('label.company_information') }}</h3>
								<div class="card-tools">
									<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.company ? $t('label.expand') : $t('label.collapse')" @click="collapse.company = !collapse.company">
										<fa :icon="collapse.company ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
									</button>
								</div>
							</div>
							<div class="card-body">
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.company_code') }}</label>
									<div class="col-md-8">
										<input v-model="declaration.company_code" type="text" class="form-control" :placeholder="$t('label.company_code')" :disabled="true" readonly tabindex="-1"/>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.company_name') }}</label>
									<div class="col-md-8">
										<input v-model="declaration.company_name" type="text" class="form-control" :placeholder="$t('label.company_name')" :disabled="true" readonly tabindex="-1"/>
									</div>
								</div>
								<div class="form-group row mb-0">
									<label class="col-md-4 col-form-label">{{ $t('label.company_address') }}</label>
									<div class="col-md-8">
										<textarea v-model="declaration.company_address" class="form-control" :placeholder="$t('label.company_address')" :disabled="true" readonly tabindex="-1" rows="3"></textarea>
									</div>
								</div>
							</div>
						</div>
						<!-- End //-->

						<!-- Start Guarantee information -->
						<div class="card card-default" v-if="declaration.security_office">
							<div class="card-header">
								<h3 class="card-title custom-card-title"><fa :icon="['fas', 'money-check-alt']"></fa> {{ $t('label.guarantee_information') }}</h3>
								<div class="card-tools">
									<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.guarantee ? $t('label.expand') : $t('label.collapse')" @click="collapse.guarantee = !collapse.guarantee">
										<fa :icon="collapse.guarantee ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
									</button>
								</div>
							</div>
							<div class="card-body">
								<div class="form-group row">
									<label for="security_office" class="col-md-4 col-form-label">{{ $t('label.office')}}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.security_office" id="security_office" class="form-control" :placeholder="$t('label.office')" disabled="true" readonly tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label for="security_serial" class="col-md-4 col-form-label">{{ $t('label.serial') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.security_serial" id="security_serial" class="form-control" :placeholder="$t('label.serial')" disabled="true" readonly tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label for="security_number" class="col-md-4 col-form-label">{{ $t('label.receipt_number') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.security_number" id="security_number" class="form-control" :placeholder="$t('label.receipt_number')" disabled="true" readonly tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.date') }}</label>
									<div class="col-md-8">
										<datepicker v-model="declaration.security_date" :bootstrapStyling="true" input-class="form-control form-control-datepicker"  format="dd/MM/yyyy" :placeholder="'DD/MM/YYYY'" :disabled="true"></datepicker>
									</div>
								</div>
								<div class="form-group row">
									<label for="security_amount" class="col-md-4 col-form-label">{{ $t('label.amount') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.security_amount" id="security_amount" class="form-control" :placeholder="$t('label.amount')" disabled="true" readonly tabindex="-1" />
									</div>
								</div>
								<div class="form-group row mb-0">
									<label class="col-md-4 col-form-label">{{ $t('label.currency')}}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.security_currency" class="form-control" :placeholder="$t('label.currency')" disabled="true" readonly tabindex="-1" />
									</div>
								</div>
							</div>
						</div>
						<!-- End // -->

						<!-- Start other information -->
						<div class="card card-default" v-if="declaration.insurance_company_code">
							<div class="card-header">
								<h3 class="card-title custom-card-title"><fa :icon="['fas', 'shield-alt']"></fa> {{ $t('label.other_information') }}</h3>
								<div class="card-tools">
									<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.other ? $t('label.expand') : $t('label.collapse')" @click="collapse.other = !collapse.other">
										<fa :icon="collapse.other ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
									</button>
								</div>
							</div>
							<div class="card-body">
								<div class="form-group row">
									<label for="insurance_company_code" class="col-md-4 col-form-label">{{ $t('label.insurance_company_code') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.insurance_company_code" id="insurance_company_code" class="form-control" :placeholder="$t('label.insurance_company_code')" disabled="true" readonly tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label for="insurance_company_name" class="col-md-4 col-form-label">{{ $t('label.insurance_company_name') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.insurance_company_name" id="insurance_company_name" class="form-control" :placeholder="$t('label.insurance_company_name')" disabled="true" readonly tabindex="-1" />
									</div>
								</div>
								<div class="form-group row">
									<label for="insurance_number" class="col-md-4 col-form-label">{{ $t('label.insurance_number') }}</label>
									<div class="col-md-8">
										<input type="text" v-model="declaration.insurance_number" id="insurance_number" class="form-control" :placeholder="$t('label.insurance_number')" disabled="true" readonly tabindex="-1" />
									</div>
								</div>
								<div class="form-group row mb-0">
									<label class="col-md-4 col-form-label">{{ $t('label.insurance_date') }}</label>
									<div class="col-md-8">
										<datepicker v-model="declaration.insurance_date" :bootstrapStyling="true" input-class="form-control form-control-datepicker"  format="dd/MM/yyyy" :placeholder="'DD/MM/YYYY'" :disabled="true"></datepicker>
									</div>
								</div>
							</div>
						</div>
						<!-- End // -->

						<!-- Start Attachment file -->
						<div class="card card-default" v-if="Object.entries(attachments).length > 0">
							<div class="card-header">
								<h3 class="card-title custom-card-title"><fa :icon="['fas', 'paperclip']"></fa> {{ $t('label.attachment') }}</h3>
								<div class="card-tools">
									<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.attachment ? $t('label.expand') : $t('label.collapse')" @click="collapse.attachment = !collapse.attachment">
										<fa :icon="collapse.attachment ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
									</button>
								</div>
							</div>
							<div class="card-body">
								<div class="form-group row">
									<label class="col-md-4 col-form-label">{{ $t('label.other') }}</label>
									<div v-if="attachments" class="col-md-8">
										<div v-for="(file, index) in attachments" :key="index" class="mb-4 mt-2">
											<button type="button" class="btn btn-success btn-sm ml-2" @click="showImage(file)" :title="$t('label.view_document')"><fa :icon="fas.faEye"/></button>
											<span class="ml-1" id="span_attachment">{{ $t('label.view_document')}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- End //-->

						<!-- Start destination changed -->
						<div v-if="destination_changeds.length > 0" class="destination_change">
							<div class="card card-info card-outline">
								<div class="card-header">
									<h3 class="card-title custom-card-title"><fa :icon="['fas', 'road']"></fa>{{ $t('label.destination_change') }}</h3>
									<div class="card-tools">
										<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.destination_change ? $t('label.expand') : $t('label.collapse')" @click="collapse.destination_change = !collapse.destination_change">
											<fa :icon="collapse.destination_change ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
										</button>
									</div>
								</div>
								<div class="card-body">
									<div class="tab-pane">
										<ul class="timeline timeline-inverse mb-0">
											<li v-for="(destination, index) in destination_changeds" :key="index">
												<template v-if="destination.action.includes('Date')">
													<fa :icon="fas.faComment" class="fa fa-bel bg-primary p-2"/>
													<div class="timeline-item">
														<span class="time">
															<fa :icon="fas.faClock"/>
															{{ destination.updated_at }}
														</span>
														<h3 class="timeline-header">
															{{$t('label.from')}}
															<b>{{ destination.document_content.properties.old.destination_office_date }}</b>
															{{$t('label.to')}} 
															<a href="javascript:void(0)" class="cursor-default">
															<b> {{ destination.document_content.properties.new.destination_office_date }}</b>
															</a>
														</h3>
														<div class="timeline-body">
															<span class="highlighter-rouge"> {{$t('label.by_user')}} </span>
															<a href="javascript:void(0)" class="cursor-default">{{destination.username}}</a>
															<!-- <a href="javascript:void(0)">{{destination.causer.first_name}} {{destination.causer.last_name}}</a> -->
														</div>
													</div>
												</template>
												<template v-else-if="destination.action.includes('Office')">
													<fa :icon="fas.faComment" class="fa fa-bel bg-primary p-2"/>
													<div class="timeline-item">
														<span class="time">
															<fa :icon="fas.faClock"/>
															{{ destination.updated_at }}
														</span>
														<h3 class="timeline-header">
															{{$t('label.from')}}
															<b>{{ destination.document_content.properties.old.destination_office_code }} -
															{{ destination.document_content.properties.old.destination_office_name }}</b>
															{{$t('label.to')}} 
															<a href="javascript:void(0)" class="cursor-default">
															<b> {{ destination.document_content.properties.new.destination_office_code }} -
															{{ destination.document_content.properties.new.destination_office_name }}</b>
															</a>
														</h3>
														<div class="timeline-body">
															<span class="highlighter-rouge"> {{$t('label.by_user')}} </span>
															<a href="javascript:void(0)" class="cursor-default">{{destination.username}}</a>
															<!-- <a href="javascript:void(0)">{{destination.causer.first_name}} {{destination.causer.last_name}}</a> -->
														</div>
													</div>
												</template>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<!-- End // -->

						<!-- Start timeline -->
						<div class="timeline">
							<div class="card card-primary card-outline">
								<div class="card-header">
									<h3 class="card-title custom-card-title"><fa :icon="['fas', 'clock']"></fa> {{ $t('label.timeline') }}</h3>
									<div class="card-tools">
										<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.timeline ? $t('label.expand') : $t('label.collapse')" @click="collapse.timeline = !collapse.timeline">
											<fa :icon="collapse.timeline ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
										</button>
									</div>
								</div>
								<div class="card-body">
									<div class="tab-pane" v-if="histories">
										<ul class="timeline timeline-inverse mb-0">
											<li v-for="(history, index) in histories" :key="index">
												<fa :icon="fas.faComment" class="fa fa-bel bg-primary p-2"/>
												<div class="timeline-item">
													<span class="time">
														<fa :icon="fas.faClock"/>
														{{ history.created_at }}
													</span>
													<h3 class="timeline-header"><a href="javascript:void(0)" class="cursor-default">{{ history.username }}</a> {{ history.action }}</h3>
													<!-- <div class="timeline-body" v-if="history.document_content">
														<code class="highlighter-rouge">{{ history.document_content }}</code>
													</div> -->
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<!-- End // -->
					</div>
				</div>
			</div>
		</div>

		<!-- Start QR code model  -->
		<div class="modal fade" id="viewQrcode" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">{{ $t('label.qrcode') }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="qrcode">
							<qrcode id="myqrcode" :value="uuid" :options="{ width: 200 }"></qrcode>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">{{$t('label.close')}}</button>
						<a id="downloadQrImage" :download="new Date(Date.now())" class="btn btn-sm btn-primary">{{ $t('label.download') }}</a>
					</div>
				</div>
			</div>
		</div>
		<!-- End //-->

		<!-- Start Lodgement assess modal -->
		<div id="lodgement" class="modal fade" tabindex="-1" role="dialog">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">

						<template v-if="lodgement.status === 'Approve'">
							<h5 class="modal-title text-success">
								<fa :icon="fas.faCheck"></fa>
								{{$t('label.lodgement_assess_approve')}}
							</h5>
						</template>
						<template v-else>
							<h5 class="modal-title text-danger">
								<fa :icon="fas.faTimes"></fa>
								{{$t('label.lodgement_assess_reject')}}
							</h5>
						</template>

						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="alert alert-danger" v-if="lodgement.errors.length > 0">
							<p class="mb-0"><strong>Whoops!</strong> Something went wrong!</p>
							<ul>
								<li v-for="(error, index) in lodgement.errors" :key="index">
									{{ error }}
								</li>
							</ul>
						</div>
						<div class="form-group row">
							<label class="control-label col-md-5">{{$t('label.description')}}</label>
							<div class="col-md-7">
								<textarea class="form-control" rows="3" v-model="lodgement.description" autofocus></textarea>
							</div>
						</div>
						<div class="form-group row">
							<label class="control-label col-md-5">{{$t('label.officer')}}</label>
							<div class="col-md-7">
								<input type="text" class="form-control" v-model="lodgement.username" disabled/>
							</div>
						</div>
						<div class="form-group row">
							<label class="control-label col-md-5">{{$t('label.created_at')}}</label>
							<div class="col-md-7">
								<input type="text" class="form-control" v-model="lodgement.created_at" disabled/>
							</div>
						</div>
						<div class="form-group row mb-0" v-show="lodgement.status == 'Decline'">
							<div class="col-md-12 table-responsive">
								<table class="table table-bordered lodgement_destination mb-0">
									<tr>
										<th>
											<label class="col-form-label">{{$t('label.fraud')}}</label>
										</th>
										<th>
											<label class="col-form-label">{{$t('label.criteria')}}</label>
										</th>
										<th style="white-space: nowrap; width: 1%;">
											<button class="btn btn-sm btn-success" @click="addLodgementItem" :title="$t('label.add')"><fa :icon="fas.faPlus"/></button>
										</th>
									</tr>
									<tr v-for="(item, key) in lodgement.items" :key="key">
										<td>
											<select class="form-control" v-model="item.fraud" v-on:change="onChange(item)">
												<option v-for="(fraud, index) in frauds" :value="fraud.name" :key="index">{{fraud.name}}</option>
											</select>
										</td>
										<td>
											<input type="text" class="form-control" v-model="item.criteria"/>
										</td>
										<th style="white-space: nowrap; width: 1%;">
											<button class="btn btn-sm btn-danger" @click="removeLodgementItem(key)" :title="$t('label.remove')"><fa :icon="fas.faTrash"/></button>
										</th>
									</tr>
								</table>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">{{$t('label.close')}}</button>
						<button type="button" class="btn btn-sm btn-primary" v-if="$hasPermission('tempvehicle.assess.create')" @click="saveLodgementAssess">{{$t('label.save')}}</button>
					</div>
				</div>
			</div>
		</div>
		<!-- End // -->

		<!-- Start amend destination office modal -->
		<div id="amendOffice" class="modal fade" tabindex="-1" role="dialog" :key="'amendOffice'">
			<form data-vv-scope="amendOffice" @submit.prevent="submitAmendment(true)">
				<div class="modal-dialog modal-lg" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<template>
								<h5 class="modal-title text-warning">
									<fa :icon="fas.faEdit"></fa>
									{{$t('label.request_changed_border_gate')}}
								</h5>
							</template>

							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="alert alert-danger" v-if="amend_error !== null && amend_error !== undefined">
								<p class="mb-0"><strong>Whoops!</strong> {{amend_error}}</p>
							</div>
							<div class="form-group row">
								<label for="destination_office" class="col-md-4 col-form-label required">{{declaration.registration_type === 'EX' ? $t('label.entry_office_name') : $t('label.exit_office_name')}}</label>
								<div class="col-md-8">
									<v-select v-model="amend_destination_office" 
										v-validate="'required'" 
										key="destination_office" 
										:name="declaration.registration_type==='EX' ? 'destination_exit_office_name' : 'destination_entry_office_name'" 
										:id="declaration.registration_type==='EX' ? 'destination_exit_office_name' : 'destination_entry_office_name'" 
										:options="offices" 
										label="full_name" 
									>
									</v-select>
									<span v-if="errors.has('amendOffice.destination_entry_office_name')" class="text-danger">
										{{ errors.first('amendOffice.destination_entry_office_name') }}
									</span>
									<span v-if="errors.has('amendOffice.destination_exit_office_name')" class="text-danger">
										{{ errors.first('amendOffice.destination_exit_office_name') }}
									</span>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-md-4 col-form-label required">{{$t('label.description')}}</label>
								<div class="col-md-8">
									<textarea v-model="amend_office.description" v-validate="'required'" name="request_change_description" id="request_change_description" class="form-control" rows="3" :key="'amendOffice'"></textarea>
									<span v-if="errors.has('amendOffice.request_change_description')" class="text-danger">
										{{ errors.first('amendOffice.request_change_description') }}
									</span>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-md-4 col-form-label">{{ $t('label.attachment') }}</label>
								<div class="col-md-8">
									<table class="table" v-if="amend_office_files.length > 0">
										<tbody>
											<tr v-if="amend_office_files.length" class="table-borderless">
												<th>{{ $t('label.name') }}</th>
												<th>{{ $t('label.size') }}</th>
												<th width="50px">{{ $t('label.delete') }}</th>
											</tr>
											<tr v-for="(file, index) in amend_office_files" :key="index">
												<td>
													<span class="text-success cursor-pointer" @click="showImage(file)" :title="$t('message.click_to_view')">
													{{ file.name.substring(file.name.length - 40 , file.name.length) }}
													</span>
												</td>
												<td>
													{{$bytesToSize(file.size)}}
												</td>
												<td class="text-right">
													<span class="btn btn-sm btn-link" @click="removeFile(amend_office_files, index)"><fa :icon="fas.faTimesCircle" class="text-danger"/></span>
												</td>
											</tr>
										</tbody>
									</table>
									<div class="row">
										<div class="col-md-7 col-12">
											<a class="btn btn-sm btn-secondary" href="#" @click.prevent="$refs.attachment_office.click()">
												<fa :icon="['fas', 'paperclip']"></fa>
												{{$t('label.choose_document')}}
											</a>
											<input type="file" class="d-none" ref="attachment_office" name="attachment_office" id="attachment_office" accept="image/x-png,image/jpg,image/jpeg,application/pdf" multiple @change="handleOfficeFilesUpload()">
										</div>
										<span class="text-muted ml-2 mt-2">{{ $t('label.other_file_criteria')}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">{{$t('label.close')}}</button>
							<button type="submit" class="btn btn-sm btn-primary">{{$t('label.save')}}</button>
						</div>
					</div>
				</div>
			</form>
		</div>
		<!-- End // -->

		<!-- Start amend destination date modal -->
		<div id="amendDate" class="modal fade" tabindex="-1" role="dialog" :key="'amendDate'">
			<form data-vv-scope="amendDate" @submit.prevent="submitAmendment(false)">
				<div class="modal-dialog modal-lg" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<template>
								<h5 class="modal-title text-warning">
									<fa :icon="fas.faEdit"></fa>
									{{declaration.registration_type === 'EX' ? $t('label.request_extended_date_of_entry') : $t('label.request_extended_date_of_exit')}}
								</h5>
							</template>

							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="alert alert-danger" v-if="amend_error !== null">
								<p class="mb-0"><strong>Whoops!</strong> {{amend_error}}</p>
							</div>
							<div class="form-group row">
								<label class="col-md-4 col-form-label required" v-if="declaration.registration_type==='EX'">{{ $t('label.entry_date')}}</label>
								<label class="col-md-4 col-form-label required" v-else>{{ $t('label.exit_date')}}</label>
								<div class="col-md-8">
									<datepicker  
										v-model="amend_date.destination_office_date"
										name="destination_entry_date" 
										id="exit_date" 
										v-validate="'required'"
										key="has_destination_entry_date" 
										v-on:selected="changeExitDate" 
										:bootstrapStyling="true" 
										:clearButton="true" 
										:highlighted="highlightedCurrentDate" 
										:language="lang"
                    :disabledDates="{ to: new Date(declaration.destination_office_date), from: new Date(allow_max_period) }"
										input-class="form-control form-control-datepicker" 
										format="dd/MM/yyyy"
										:placeholder="'DD/MM/YYYY'">
									</datepicker>
									<span v-if="errors.has('amendDate.destination_entry_date')" class="text-danger">
										{{ errors.first('amendDate.destination_entry_date') }}
									</span>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-md-4 col-form-label required">{{$t('label.description')}}</label>
								<div class="col-md-8">
									<textarea v-model="amend_date.description" v-validate="'required'" name="request_change_description2" id="request_change_description2" class="form-control" rows="3" :key="'amendDate'"></textarea>
									<span v-if="errors.has('amendDate.request_change_description2')" class="text-danger">
										{{ errors.first('amendDate.request_change_description2') }}
									</span>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-md-4 col-form-label">{{ $t('label.attachment') }}</label>
								<div class="col-md-8">
									<table class="table" v-if="amend_date_files.length > 0">
										<tbody>
											<tr v-if="amend_date_files.length" class="table-borderless">
												<th>{{ $t('label.name') }}</th>
												<th>{{ $t('label.size') }}</th>
												<th width="50px">{{ $t('label.delete') }}</th>
											</tr>
											<tr v-for="(file, index) in amend_date_files" :key="index">
												<td>
													<span class="text-success cursor-pointer" @click="showImage(file)" :title="$t('message.click_to_view')">
													{{ file.name.substring(file.name.length - 40 , file.name.length) }}
													</span>
												</td>
												<td>
													{{$bytesToSize(file.size)}}
												</td>
												<td class="text-right">
													<span class="btn btn-sm btn-link" @click="removeFile(amend_date_files, index)"><fa :icon="fas.faTimesCircle" class="text-danger"/></span>
												</td>
											</tr>
										</tbody>
									</table>
									<div class="row">
										<div class="col-md-7 col-12">
											<a class="btn btn-sm btn-secondary" href="#" @click.prevent="$refs.attachment_date.click()">
												<fa :icon="['fas', 'paperclip']"></fa>
												{{$t('label.choose_document')}}
											</a>
											<input type="file" class="d-none" ref="attachment_date" name="attachment_date" id="attachment_date" accept="image/x-png,image/jpg,image/jpeg,application/pdf" multiple @change="handleDateFilesUpload()">
										</div>
										<span class="text-muted ml-3 mt-2">{{ $t('label.other_file_criteria')}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">{{$t('label.close')}}</button>
							<button type="submit" class="btn btn-sm btn-primary">{{$t('label.save')}}</button>
						</div>
					</div>
				</div>
			</form>
		</div>
		<!-- End // -->

		<!-- Start approve or decline amendment modal -->
		<div id="amendApproveOrDecline" class="modal fade" tabindex="-1" role="dialog" :key="'amendApproveOrDecline'">
			<form data-vv-scope="amendApproveOrDecline" @submit.prevent="doVerifyAmendment(verify_amend.amend_id, verify_amend.do_action, verify_amend.action_on, verify_amend.description)">
				<div class="modal-dialog modal-lg" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<template>
								<h5 v-if="verify_amend.action_on === 'office'" class="modal-title text-danger">
									{{verify_amend.do_action === 'Approve' ? $t('label.approve_changed_border_gate') : $t('label.decline_changed_border_gate')}}
								</h5>
								<h5 v-else class="modal-title text-danger">
									<template v-if="verify_amend.do_action === 'Approve'">
										{{declaration.registration_type === 'EX' ? $t('label.approve_extended_date_of_exit') : $t('label.approve_extended_date_of_entry')}}
									</template>
									<template v-else>
										{{declaration.registration_type === 'EX' ? $t('label.decline_extended_date_of_exit') : $t('label.decline_extended_date_of_entry')}}
									</template>
								</h5>
							</template>

							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="alert alert-danger" v-if="amend_error !== null">
								<p class="mb-0"><strong>Whoops!</strong> {{amend_error}}</p>
							</div>
							<div class="form-group row">
								<label class="col-md-3 col-form-label required">{{$t('label.description')}}</label>
								<div class="col-md-9">
									<textarea v-model="verify_amend.description" v-validate="'required'" name="verify_amend_description" id="verify_amend_description" class="form-control" rows="3"></textarea>
									<span v-if="errors.has('amendApproveOrDecline.verify_amend_description')" class="text-danger">
										{{ errors.first('amendApproveOrDecline.verify_amend_description') }}
									</span>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">{{$t('label.close')}}</button>
							<button type="submit" class="btn btn-sm btn-primary">{{$t('label.save')}}</button>
						</div>
					</div>
				</div>
			</form>
		</div>
		<!-- End // -->

		<!-- Start Destination assess modal -->
		<template v-if="declaration.lodgement != null && ['Approve','approve','APPROVE'].includes(declaration.lodgement.status)">
			<div id="destination" class="modal fade" tabindex="-1" role="dialog">
				<div class="modal-dialog modal-lg" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">{{$t('label.destination_assess')}}</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="alert alert-danger" v-if="destination.errors.length > 0">
								<p class="mb-0"><strong>Whoops!</strong> Something went wrong!</p>
								<ul>
									<li v-for="(error, index) in destination.errors" :key="index">
										{{ error }}
									</li>
								</ul>
							</div>
							<div class="form-group row">
								<label class="control-label col-md-5">{{$t('label.status')}}</label>
								<div class="col-md-7">
									<select class="form-control" v-model="destination.status" :disabled="isDestinationAssessed(declaration)">
										<option value=""></option>
										<option value="Approve">{{$t('label.approve')}}</option>
										<option value="Decline">{{$t('label.decline')}}</option>
									</select>
								</div>
							</div>
							<div class="form-group row">
								<label class="control-label col-md-5">{{$t('label.description')}}</label>
								<div class="col-md-7">
									<textarea class="form-control" rows="3" v-model="destination.description" :disabled="isDestinationAssessed(declaration)"></textarea>
								</div>
							</div>
							<div class="form-group row">
								<label class="control-label col-md-5">{{$t('label.officer')}}</label>
								<div class="col-md-7">
									<input type="text" class="form-control" v-model="destination.username" readonly/>
								</div>
							</div>
							<div class="form-group row">
								<label class="control-label col-md-5">{{$t('label.created_at')}}</label>
								<div class="col-md-7">
									<input type="text" class="form-control" v-model="destination.created_at" readonly/>
								</div>
							</div>
							<div class="form-group row" :class="destination.status == 'Decline' ? '': 'mb-0'">
								<label class="control-label col-md-5">{{$t('label.updated_at')}}</label>
								<div class="col-md-7">
									<input type="text" class="form-control" v-model="destination.updated_at" readonly/>
								</div>
							</div>
							<div class="form-group row mb-0" v-show="destination.status == 'Decline'">
								<div class="col-md-12 table-responsive">
									<table class="table table-bordered lodgement_destination mb-0">
										<tr>
											<th>
												<label class="col-form-label">{{$t('label.fraud')}}</label>
											</th>
											<th>
												<label class="col-form-label">{{$t('label.criteria')}}</label>
											</th>
											<th v-if="!isDestinationAssessed(declaration)" style="white-space: nowrap; width: 1%;">
												<button class="btn btn-sm btn-success" @click="addDestinationItem" :title="$t('label.add')"><fa :icon="fas.faPlus"/></button>
											</th>
										</tr>
										<tr v-for="(item, key) in destination.items" :key="key">
											<td>
												<select class="form-control" v-model="item.fraud" v-on:change="onChange(item)" :disabled="isDestinationAssessed(declaration)">
													<option v-for="(fraud, index) in frauds" :value="fraud.name" :key="index">{{fraud.name}}</option>
												</select>
											</td>
											<td>
												<input type="text" class="form-control" v-model="item.criteria" :readonly="isDestinationAssessed(declaration)"/>
											</td>
											<th v-if="!isDestinationAssessed(declaration)" style="white-space: nowrap; width: 1%;">
												<button class="btn btn-sm btn-danger" @click="removeDestinationItem(key)" :title="$t('label.remove')"><fa :icon="fas.faTrash"/></button>
											</th>
										</tr>
									</table>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">{{$t('label.close')}}</button>
							<button v-if="$hasPermission('tempvehicle.destination.create') && !isDestinationAssessed(declaration)" type="button" class="btn btn-sm btn-primary" @click="saveDestinationAssess">{{$t('label.save')}}</button>
						</div>
					</div>
				</div>
			</div>
		</template>
		<!-- End // -->

		<!-- Start Overstay modal -->
		<template v-if="declaration.lodgement != null && ['Approve','approve','APPROVE'].includes(declaration.lodgement.status) && is_overstay === true">
			<div id="resolve" class="modal fade" tabindex="-1" role="dialog">
				<div class="modal-dialog modal-lg" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">{{$t('label.resolve')}}</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="alert alert-danger" v-if="resolve.errors.length > 0">
								<p class="mb-0"><strong>Whoops!</strong> Something went wrong!</p>
								<ul>
									<li v-for="(error, index) in resolve.errors" :key="index">
										{{ error }}
									</li>
								</ul>
							</div>
							<div class="form-group row">
								<label class="control-label col-md-5">{{$t('label.status')}}</label>
								<div class="col-md-7">
									<select class="form-control" v-model="resolve.status" :disabled="isResolveAssessApproved">
										<option value=""></option>
										<option value="Approve">{{$t('label.approve')}}</option>
										<option value="Decline">{{$t('label.decline')}}</option>
									</select>
								</div>
							</div>
							<div class="form-group row">
								<label class="control-label col-md-5">{{$t('label.description')}}</label>
								<div class="col-md-7">
									<textarea class="form-control" rows="3" v-model="resolve.description" :disabled="isResolveAssessApproved"></textarea>
								</div>
							</div>
							<div class="form-group row">
								<label class="control-label col-md-5">{{$t('label.officer')}}</label>
								<div class="col-md-7">
									<input type="text" class="form-control" v-model="resolve.username" readonly/>
								</div>
							</div>
							<div class="form-group row">
								<label class="control-label col-md-5">{{$t('label.created_at')}}</label>
								<div class="col-md-7">
									<input type="text" class="form-control" v-model="resolve.created_at" readonly/>
								</div>
							</div>
							<div class="form-group row" :class="resolve.status == 'Decline' ? '': 'mb-0'">
								<label class="control-label col-md-5">{{$t('label.updated_at')}}</label>
								<div class="col-md-7">
									<input type="text" class="form-control" v-model="resolve.updated_at" readonly/>
								</div>
							</div>
							<div class="form-group row mb-0" v-show="resolve.status == 'Decline'">
								<div class="col-md-12 table-responsive">
									<table class="table table-bordered lodgement_destination mb-0">
										<tr>
											<th>
												<label class="col-form-label">{{$t('label.fraud')}}</label>
											</th>
											<th>
												<label class="col-form-label">{{$t('label.criteria')}}</label>
											</th>
											<th style="white-space: nowrap; width: 1%;">
												<button class="btn btn-sm btn-success" @click="addResolveItem" :title="$t('label.add')"><fa :icon="fas.faPlus"/></button>
											</th>
										</tr>
										<tr v-for="(item, key) in resolve.items" :key="key">
											<td>
												<select class="form-control" v-model="item.fraud" v-on:change="onChange(item)">
													<option v-for="(fraud, index) in frauds" :value="fraud.name" :key="index">{{fraud.name}}</option>
												</select>
											</td>
											<td>
												<input type="text" class="form-control" v-model="item.criteria"/>
											</td>
											<th style="white-space: nowrap; width: 1%;">
												<button class="btn btn-sm btn-danger" @click="removeResolveItem(key)" :title="$t('label.remove')"><fa :icon="fas.faTrash"/></button>
											</th>
										</tr>
									</table>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">{{$t('label.close')}}</button>
							<button type="button" class="btn btn-sm btn-primary" v-if="$hasPermission('tempvehicle.destination.create') && !isResolveAssessApproved" @click="saveResolve">{{$t('label.save')}}</button>
						</div>
					</div>
				</div>
			</div>
		</template>
		<!-- End // -->

	</div>
</template>

<script>
import { fas } from "@fortawesome/free-solid-svg-icons";
import print from 'print-js';
export default {
	name: 'ViewApplication',
	components: {

    },
	data(){
        return {
			baseURI: "",
			imageBaseUrl: "",
			uuid: 'abc',
			is_overstay: false,
      declaration: {
				drivers: [],
				vehicles: [],
				owner: {}
			},
			vehicle: {},		
			lodgement: {
                status: '',
                description: '',
                username: '',
                created_at: '',
                updated_at: '',
                items: [
                    {
                        fraud: '',
                        fraud_code: '',
                        criteria: ''
                    }
                ],
                errors: [],
			},
			destination: {
                status: '',
                description: '',
                username: '',
                created_at: '',
                updated_at: '',
                items: [
                    {
                        fraud: '',
                        fraud_code: '',
                        criteria: ''
                    }
                ],
                errors: [],
            },
      resolve: {
                status: '',
                description: '',
                username: '',
                created_at: '',
                updated_at: '',
                items: [
                    {
                        fraud: '',
                        fraud_code: '',
                        criteria: ''
                    }
                ],
                errors: [],
            },
			frauds: [],
			histories: [],
			destination_changeds: [],
			permission: {
				viewLodgementAssess: false,
				editLodgementAssess: false,
				viewDestinationAssess: false,
				editDestinationAssess: true 
			},
			attachments: {},
			srcPrint: '',
			data_is_fetched: false,
			user: {},
			collapse:{
				customs: false,
				owner: false,
				vehicle: false,
				driver: false,
				company: false,
				guarantee: false,
				other: false,
				attachment: false,
				destination_change: false,
				timeline: false,
			},
			amend_destination_office: {},
			amend_office: {},
			amend_date: {},
			amend_office_files: [],
			amend_date_files: [],
			amendments: [],
			verify_amend : {
				amend_id: '',
				do_action: '',
				action_on: '',
				description: ''
			},
			amend_error: null,
			//offices: [],
      MAX_PERIOD: 0,
      MAX_EXIT_PERIOD: 0,
        }
    },
    computed: {
      fas() { return fas; },
      offices(){
        return this.$store.getters['reference/offices'];
      },
      isResolveAssessApproved(){
        if(!this.declaration.resolve){
          return false;
        }
        const resolve = this.declaration.resolve;
        return resolve.status === 'Approve';
      },
      allow_max_period(){
        let type = this.declaration.registration_type;
        let startDate = new Date();
        if(this.declaration.lodgement_office_date){
          startDate = new Date(this.declaration.lodgement_office_date);
        }

        let selected_max_period = this.MAX_PERIOD;
        if(type === "IM"){
          startDate = new Date(this.declaration.destination_office_date);
        }else{
          selected_max_period = this.MAX_EXIT_PERIOD;
        }

        const maxDate = new Date(startDate);
        maxDate.setDate(maxDate.getDate() + parseInt(selected_max_period));
        return maxDate;
      }
    },
  mounted () {
        this.$nextTick(() => {
			this.uuid = this.$route.params.uuid;
			this.display();
			//this.getOffices();
			this.getHistory();
			this.getProfile();
		});
        this.imageBaseUrl = process.env.VUE_APP_BACKEND_API_URL + '/';
        $(".vdp-datepicker").find("input").css("background-color", "#e9ecef");
    this.MAX_PERIOD = process.env.VUE_APP_MAX_PERIOD || 30;
    this.MAX_EXIT_PERIOD = process.env.VUE_APP_MAX_EXIT_PERIOD || 365;
	},
	updated() {
		this.downloadQrcode();
		this.srcPrint = process.env.VUE_APP_BACKEND_API_URL + '/applications/print/'+this.uuid;
	},
	watch :{
		"amend_destination_office": function(val) {
			if(val != null) {
				this.amend_office.destination_office_code = val.code;
				this.amend_office.destination_office_name = val.name;
			}
		},
		"histories": function(val){
			this.destination_changeds = val.filter(function(item) {
				item.document_content = JSON.parse(item.document_content);
				return (item.action.includes("Date") || item.action.includes("Office")) && item.action.includes("Approved");
			});
		}
	},
    methods: {
		getProfile() {
			this.$store.state.loading.status = true;
			let url = this.baseURI + 'profile';
			GDCE_Client.requestApi("GET", url).then(response => {
				this.user = response.data;
				if(this.$hasPermission('tempvehicle.assess.view')){
					this.getLodgementAssess();
				}
				if(this.$hasPermission('tempvehicle.fraud.view')) {
					this.getFrauds();
				}
				this.$store.state.loading.status = false;
			});
		},
    display() {
      this.$store.state.loading.status = true;
			let url = this.baseURI+'/applications/'+this.uuid;
			GDCE_Client.requestApi("GET", url).then(response => {
                if(response.status) {
					this.declaration = response.data;
					this.attachments = response.attachments;
					this.amendments = response.data.amendments;
					this.amend_destination_office = {
						code: this.declaration.destination_office_code,
						name: this.declaration.destination_office_name,
						full_name: this.declaration.destination_office_code+' - '+this.declaration.destination_office_name
					}
					this.amend_date.destination_office_date = this.declaration.destination_office_date;
                } else {
                    this.declaration = {
                        drivers: {},
                        owner: {},
                        vehicles: {}
                    }
                }
				this.$store.state.loading.status = false;
			}).catch(error => {
				this.$store.state.loading.status = false;
				this.$router.push('erros/404');
			});
		},
		downloadQrcode() {
			let canvas = document.getElementById("myqrcode");
			let img    = canvas.toDataURL("image/jpeg");
			document.getElementById('downloadQrImage').setAttribute('href', img);
		},
		showQrcode() {
			let canvas = document.getElementById("myqrcode");
			let img    = canvas.toDataURL("image/jpeg");
			document.write('<img src="'+img+'" />');
		},
		viewVehicle(item){
			this.vehicle = item;
			$("#viewVehicle").modal('show');
		},
		viewVehicleDetail() {
			if(this.declaration.vehicles[0].uuid){
				window.open('/vehicle/' + this.declaration.vehicles[0].uuid, '_blank');
			}
		},
		viewDriver(driver){
			if(driver){
				window.open('/driver/' + driver.uuid, '_blank');
			}
		},
		viewDriverDetail() {
			if(this.declaration.drivers[0].uuid){
				window.open('/driver/' + this.declaration.drivers[0].uuid, '_blank');
			}
		},
		getLodgementAssess(){
            this.$store.state.loading.status = true;            
            GDCE_Client.requestApi("GET", "assesses/lodgement/" + this.uuid).then(response => {
                if(response.data){
                    this.lodgement.id = response.data.id;
                    this.lodgement.status = response.data.status;
                    this.lodgement.description = response.data.description;
                    this.lodgement.username = response.data.username;
                    this.lodgement.created_at = response.data.created_at;
					this.lodgement.updated_at = response.data.updated_at;
					if(this.$hasPermission('tempvehicle.destination.view')){
						this.getDestinationAssess(); 
					}
                    if(response.data.items.length > 0){
						this.lodgement.items = response.data.items;
                    }
                    this.is_overstay = response.data.is_overstay;
                    if(this.$hasPermission('tempvehicle.destination.view') && this.is_overstay){
						this.getResolve();
                    }
				}
                this.$store.state.loading.status = false;
            });
		},        
    saveLodgementAssess(){
        this.$store.state.loading.status = true;
        this.lodgement.errors = [];
        GDCE_Client.requestApi("POST", "assesses/lodgement/" + this.uuid, this.lodgement).then(response => {
            this.$store.state.loading.status = false;
            this.lodgement.id = response.data.id;
    $('#lodgement').modal('hide');

    this.display();
    this.getHistory();
        }).catch(error => {
            this.$store.state.loading.status = false;
            if (typeof error.data === 'object') {
                this.lodgement.errors = _.flatten(_.toArray(error.data.errors));
            } else {
                this.lodgement.errors = ['Something went wrong. Please try again.'];
            }
        });
    },
    addLodgementItem(){
        let item = {
            fraud: '',
            fraud_code: '',
            criteria: ''
        }
        this.lodgement.items.push(item);
    },
    removeLodgementItem(key){
        if(this.lodgement.items.length > 1){
            this.lodgement.items.splice(key, 1)
        }
},
		getDestinationAssess(){
            this.$store.state.loading.status = true;            
            GDCE_Client.requestApi("GET", "assesses/destination/" + this.uuid).then(response => {
                if(response.data){
                    this.destination.id = response.data.id;
                    this.destination.status = response.data.status;
					this.destination.description = response.data.description;
					this.destination.username = response.data.username;
                    this.destination.created_at = response.data.created_at;
                    this.destination.updated_at = response.data.updated_at;
                    if(response.data.items.length > 0){
                        this.destination.items = response.data.items;
                    }
                }
                this.$store.state.loading.status = false;
            }).catch(error => {
                this.$store.state.loading.status = false;
            });
		},
		saveDestinationAssess(){
            this.$store.state.loading.status = true;
            this.destination.errors = [];
            GDCE_Client.requestApi("POST", "assesses/destination/" + this.uuid, this.destination).then(response => {
                this.$store.state.loading.status = false;
				this.destination.id = response.data.id;
                $('#destination').modal('hide');

				this.display();
				this.getHistory();
            }).catch(error => {
                this.$store.state.loading.status = false;
                if (typeof error.data === 'object') {
                    this.destination.errors = _.flatten(_.toArray(error.data.errors));
                } else {
                    this.destination.errors = ['Something went wrong. Please try again.'];
                }
            });
        },
    addDestinationItem(){
        let item = {
            fraud: '',
            fraud_code: '',
            criteria: ''
        };
        this.destination.items.push(item);
    },
    removeDestinationItem(key){
        if(this.destination.items.length > 1){
            this.destination.items.splice(key, 1)
        }
    },
		getFrauds(){
			if(this.$hasPermission('tempvehicle.fraud.view')){
				this.$store.state.loading.status = true;
				GDCE_Client.requestApi("GET", "frauds").then(response => {
					this.frauds = response.data;
					this.$store.state.loading.status = false;
				});
			}
		},
    onChange(item){
        item.fraud_code = this.frauds.filter(function(fraud){
            return item.fraud == fraud.name;
        })[0].code;
		},
		getHistory() {
			let url = this.baseURI+'/applications/'+this.uuid+'/history';
			GDCE_Client.requestApi("GET", url).then(response => {
				if(response.status) {
					this.histories = response.data;
					this.data_is_fetched = true;
                } else {
					this.histories = [];
                }
				this.$store.state.loading.status = false;
			}).catch(error => {
				this.$store.state.loading.status = false;
				this.$router.push('erros/404');
			});
		},
		print1(src){
			printJS({
				printable: src,
				type: 'pdf',
				showModal: true,
				modalMessage: this.$t('label.loading')
			});
		},
    getResolve(){
        this.$store.state.loading.status = true;
        GDCE_Client.requestApi("GET", "assesses/resolve/" + this.uuid).then(response => {
            if(response.data){
                this.resolve.id = response.data.id;
                this.resolve.status = response.data.status;
                this.resolve.description = response.data.description;
                this.resolve.username = response.data.username;
                this.resolve.created_at = response.data.created_at;
                this.resolve.updated_at = response.data.updated_at;
                if(response.data.items.length > 0){
                    this.resolve.items = response.data.items;
                }
            }
            this.$store.state.loading.status = false;
        }).catch(error => {
            this.$store.state.loading.status = false;
        });
    },
    saveResolve(){
        this.$store.state.loading.status = true;
        this.resolve.errors = [];
        GDCE_Client.requestApi("POST", "assesses/resolve/" + this.uuid, this.resolve).then(response => {
            this.$store.state.loading.status = false;
            this.resolve.id = response.data.id;
            $('#resolve').modal('hide');
        }).catch(error => {
            this.$store.state.loading.status = false;
            if (typeof error.data === 'object') {
                this.resolve.errors = _.flatten(_.toArray(error.data.errors));
            } else {
                this.resolve.errors = ['Something went wrong. Please try again.'];
            }
        });
    },
    addResolveItem(){
        let item = {
            fraud: '',
            fraud_code: '',
            criteria: ''
        };
        this.resolve.items.push(item);
    },
    removeResolveItem(key){
        if(this.resolve.items.length > 1){
            this.resolve.items.splice(key, 1)
        }
    },
		performLodgementAction(status){
			this.lodgement.status = status;
			this.lodgement.username = this.user.full_name;
			this.lodgement.created_at = new Date().toDateString();
		},
		getAmendment(type = null, id=false){
			if(!Array.isArray(this.amendments)){
				return null;
			}
			if(type === 'office'){
				var amend =  this.amendments.filter(function(item) {
					return item.destination_office_code !== null && item.status === 'pending';
				});

				if(amend.length === 0){return null;}
				if(id === true){ return amend[0].id;}

				return {
					new : amend[0].destination_office_code+' - '+amend[0].destination_office_name,
					old: amend[0].old_destination_office_code+' - '+amend[0].old_destination_office_name,
					attachments: amend[0].attachments,
					description: amend[0].description
				} 

			}else if(type === 'date'){
				var amend =  this.amendments.filter(function(item) {
					return item.destination_office_date !== null && item.status === 'pending';
				});

				if(amend.length === 0){return null;}
				if(id === true){ return amend[0].id;}

				return {
					new: amend[0].destination_office_date,
					old: amend[0].old_destination_office_date,
					attachments: amend[0].attachments,
					description: amend[0].description
				}
			}
			return null;
		},
		doAmendment(id = null, do_action = 'Approve', action_on = null, description = ''){
            this.$swal({
                title: this.$t('label.confirm'),
                text: do_action == 'Approve' ? this.$t('message.approve_amendment') : this.$t('message.decline_amendment'),
                icon: "warning",
                buttons: true,
                dangerMode: true,
				align: 'top-right'
            }).then((Continue) => {
                if (Continue) {
					this.$store.state.loading.status = true;
					let url = do_action == 'cancel' ? 'assesses/amend-cancel' : 'assesses/amend';
					GDCE_Client.requestApi("POST", url, {action : do_action, action_on: action_on, amend_id : id, description: description}).then(response => {
						if(response.status == true){
							this.display();
							this.getHistory();
							window.$('#amendApproveOrDecline').modal('hide');
						}
						this.$store.state.loading.status = false;
					}).catch(error => {
						this.$store.state.loading.status = false;
					});
                }
            });
		},
		showVerifyAmendmentModal(id = null, do_action = 'Approve', action_on = null){
			this.verify_amend.amend_id = id;
			this.verify_amend.do_action = do_action;
			this.verify_amend.action_on = action_on;
			this.verify_amend.description = '';
			window.$('#amendApproveOrDecline').modal('show');
		},
		doVerifyAmendment(id, do_action, action_on, description){
			this.$validator.validate('amendApproveOrDecline.*').then(passed => { 
				if(passed){
					this.doAmendment(id, do_action, action_on, description);
				}
			});
		},
		clearDestinationOffice(data) {
			if(data === null) {
				this.declaration.destination_office_code = "";
				this.declaration.destination_office_name = "";
			}
		},
		changeExitDate(dateChange) {
			this.declaration.destination_office_date = new Date(dateChange).getTime();
		},
		getOffices() {
			this.$store.state.loading.status = true;
			let url = this.baseURI+'/reference/offices';
			GDCE_Client.requestApi("GET", url).then(response => {
				let offices = [];
				response.data.forEach(function(office) {
					offices.push({name: office.name, code: office.code, full_name: office.code + " - " + office.name});
				});
				this.offices = offices;
				this.$store.state.loading.status = false;
			});
		},
		handleOfficeFilesUpload(){
			let uploadedFiles = this.$refs.attachment_office.files;
			for( var i = 0; i < uploadedFiles.length; i++ ){
				if(this.hasExtension(uploadedFiles[i].name, ['.jpeg','.png','.jpg','.pdf'])){
					if(uploadedFiles[i].size < (1024 * 1024) * 10){
						this.amend_office_files.push( uploadedFiles[i] );
					}
				}
			}
		},
		handleDateFilesUpload(){
			let uploadedFiles = this.$refs.attachment_date.files;
			for( var i = 0; i < uploadedFiles.length; i++ ){
				if(this.hasExtension(uploadedFiles[i].name, ['.jpeg','.png','.jpg','.pdf'])){
					if(uploadedFiles[i].size < (1024 * 1024) * 10){
						this.amend_date_files.push( uploadedFiles[i] );
					}
				}
			}
		},
		hasExtension(file_name, exts) {
			var extention = file_name.substring(file_name.length - 4,file_name.length);
			for(var i = 0; i < exts.length; i++){
				if(extention === exts[i]){
					return true;
				}
			}
		},
		showImage(src) {
			if(src.name.includes(this.declaration.uuid)){
				// window.open( this.imageBaseUrl + src.name);
				window.open(this.imageBaseUrl + 'attachment?path=' + src.name);
			}else{
				window.open(URL.createObjectURL(src));
			}
		},
		viewImage(src) {
			window.open(this.imageBaseUrl + 'attachment?path=' + src);
		},
		removeFile(files, key){
			files.splice( key, 1 );
		},
		submitAmendment(is_office = true){
			this.amend_error = null;
			var scope = is_office === true ? 'amendOffice.*' : 'amendDate.*';
			this.$validator.validate(scope).then(passed => {
				if(passed) {
					this.$store.state.loading.status = true;
					let formData = new FormData();
					if(is_office){
						formData.set('destination_office_code', this.amend_office.destination_office_code);
						formData.set('destination_office_name', this.amend_office.destination_office_name);
						formData.set('description', this.amend_office.description);
						formData.set('is_office', 1);
						if(this.amend_office_files.length > 0){
							formData.set('declaration_id', this.declaration.uuid);
							for( var i = 0; i < this.amend_office_files.length; i++ ){
								let file = this.amend_office_files[i];
								formData.set('attachments[' + i + ']', file);
							}
						}
					}else{
						formData.set('destination_office_date', this.$formatObjectDate(this.amend_date.destination_office_date, true));
						formData.set('description', this.amend_date.description);
						formData.set('is_office', 0);
						if(this.amend_date_files.length > 0){
							formData.set('declaration_id', this.declaration.uuid);
							for( var i = 0; i < this.amend_date_files.length; i++ ){
								let file = this.amend_date_files[i];
								formData.set('attachments[' + i + ']', file);
							}
						}
					}
					const config = {
						headers: { "Content-Type": "multipart/form-data" }
					};
					let url = this.baseURI + "/applications/amend/" + this.declaration.uuid;
					GDCE_Client.requestApi("POST", url, formData, config).then( respone => {
						if(respone.status == true){
							// this.$router.push({ name: 'ViewApplication', params: { uuid: app_uuid }});
							this.display();
							this.getHistory();
							if(is_office){
								window.$('#amendOffice').modal('toggle'); 
							}else{
								window.$('#amendDate').modal('toggle'); 
							}
						}else{
							this.amend_error = respone.message;
						}
						this.$store.state.loading.status = false;
					}).catch(error => {
						this.$store.state.loading.status = false;
					});
				}
			});
		},
    isDestinationAssessed(declaration){
		  return !!declaration.destination;
    },
    isLodgementAssessDeclined(declaration) {
      if(!declaration.lodgement){
        return false;
      }
      const lodgement = declaration.lodgement;
      return lodgement.status === 'Decline';
    },
	prepareForModalData(type){
      if(type === "resolve" && !this.resolve.username){
        this.resolve.username   = this.user.full_name;
        this.resolve.created_at = new Date().toDateString();
        this.resolve.updated_at = new Date().toDateString();
      }
      if(type === "destination" && !this.destination.username){
        this.destination.username   = this.user.full_name;
        this.destination.created_at = new Date().toDateString();
        this.destination.updated_at = new Date().toDateString();
      }
	},
	print(url) {
    this.$swal({
      title: this.$t('label.print'),
      text: this.$t('message.choose_print_type'),
      icon: 'warning',
      buttons: {
        all: {
          text: `📄 ${this.$t('label.print_all')}`,
          value: 'all',
          className: 'swal-button-all'
        },
        declare: {
          text: `📄 ${this.$t('label.print_declaration')}`,
          value: 'declare',
          className: 'swal-button-declare'
        },
        pass: {
          text: `🪪 ${this.$t('label.print_conveyance_pass')}`,
          value: 'pass',
          className: 'swal-button-pass'
        },
      },
    }).then(choose => {
      if (choose == null) {
        return false; // Cancel print
      }
      url += "?type=" + choose;

		var isFirefox = navigator.userAgent.indexOf("Firefox") > 0;
		var isIE      = (navigator.userAgent.indexOf('MSIE') > -1 || navigator.userAgent.indexOf('Trident') > -1);
        var isiOS     = (/iPad|iPhone|iPod/i.test(navigator.userAgent) && !window.MSStream);
        var isAndroid = (/android/i.test(navigator.userAgent));
        if(isAndroid || isiOS){
            // Android and iOS open PDF in new tab.
            window.open(url, "_blank");
        }else if(isFirefox || isIE){
            // Firefox and IE continue in printIframe function.
			this.$store.state.loading.status = true;
		}else{
			// Google Chrome, Opera, Safari, Microsoft Edge, ...
			printJS({
				printable: url,
				type: 'pdf',
				showModal: true,
				modalMessage: this.$t('label.loading')
			});

			return; // Break.
		}

		// Specify the aforementioned delay for Firefox. 1000 seems to work. 100 is not enough.
		var firefoxDelay = 1000;
	
		var iframe = document.createElement("iframe");
		iframe.style.cssText = "width: 1px; height: 100px; position: fixed; left: 0; top: 0; opacity: 0; border-width: 0; margin: 0; padding: 0";
	
		var xhr = new XMLHttpRequest();
		try {
			xhr.responseType = "arraybuffer";
		} catch (e) {
			// This is probably IE 11, in which case we can go no further and just open the PDF in a new tab
			window.open(url, "_blank");
			return;
		}
	
		xhr.addEventListener("load", () => {
			if (xhr.status === 200 || xhr.status === 201) {
			var pdfBlob = new Blob([xhr.response], { type: "application/pdf" });
			var iframeUrl = URL.createObjectURL(pdfBlob);
			iframe.src = iframeUrl;
	
			iframe.addEventListener("load", () => {
				var printIframe = () => {
					try {
						iframe.focus()
						try {
							iframe.contentWindow.document.execCommand("print", false, null);
						} catch (e) {
							iframe.contentWindow.print();
						}
					} catch (error) {
                        console.error("Print failed: " + error, error);
                        window.open(url, "_blank");
					} finally {
						iframe.style.visibility = "hidden";
						iframe.style.left = "-1px";
						URL.revokeObjectURL(iframeUrl);
						this.$store.state.loading.status = false;
					}
				}
	
				// Add a delay for Firefox
				if (isFirefox) {
					window.setTimeout(printIframe, firefoxDelay);
				} else {
					printIframe();
				}
			});
	
			document.body.appendChild(iframe);
			}
		});
	
		xhr.open("GET", url, true);
		xhr.send();

    });

    }
  }
}
</script>
<style>
	h3.custom-card-title svg{
		font-size: 22px !important;
	}
	.custom-card-title{
		color: #205670;
		text-transform: none !important;
	}

	.pointer {
        cursor: pointer;
    }
	#qrcode {
		width: 160px;
		height: 160px;
		margin-left: auto;
		margin-right: auto;
		border: 1px solid #d4d4d4;
		padding: 15px;
	}
	table.lodgement_destination {
        border-collapse: collapse;
    }
    table.lodgement_destination tr td, table.lodgement_destination tr th{
		padding: 0px !important;
        border-top: 0px !important;
        border-collapse: collapse;
    }
    table.lodgement_destination th {
        text-align: center;
    }
    table.lodgement_destination .form-control{
		border-radius: 0;
	}
	.qrcode {
		width: 202px;
		height: 202px;
		margin: 0px auto;
		border: 1px solid #afafaf;
	}

	/* 100% Image Width on Smaller Screens */
	@media only screen and (max-width: 700px) {
		.modal-content {
			width: 100%;
		}
	}
	.cursor-default {
		cursor: default !important;
	}
  /* Custom buttons */
  .swal-footer {
    text-align: center !important;
  }
  .swal-button-all {
    background-color: #3085d6 !important;
    padding: 10px 12px !important;
  }
  .swal-button-all:hover {
    background-color: #2874c2 !important;
  }

  .swal-button-declare {
    background-color: #28a745 !important;
    padding: 10px 12px !important;
  }
  .swal-button-declare:hover {
    background-color: #218838 !important;
  }

  .swal-button-pass {
    background-color: #ffc107 !important;
    color: #000;
    padding: 10px 12px !important;
  }
  .swal-button-pass:hover {
    background-color: #e0a800 !important;
  }
</style>